import { createSelector } from '@reduxjs/toolkit';
import { PaymentIntent } from '@stripe/stripe-js';
import { RootState } from 'store/create-store';
import { PayResponseData, PayState, TransactionResponse } from 'store/pay/types';

export const getPayState = (state: RootState): PayState => state.pay;

export const getPayData = createSelector(
  [getPayState],
  (state: PayState): PayResponseData => state.data
);

export const getPayDafData = createSelector(
  [getPayState],
  (state: PayState): PayResponseData => state.dafData
);

export const getPayDafError = createSelector(
  [getPayState],
  (state: PayState): string => state.dafError
);

export const getPayStripePaymentIntent = createSelector(
  [getPayState],
  (state: PayState): PaymentIntent => state.stripePaymentIntent
);

export const getCompletedTransactions = createSelector(
  [getPayState],
  (state: PayState): TransactionResponse[] => state.completedTransactions
);
